import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Spinner,
  Alert,
  Modal,
} from "react-bootstrap";
import Select from 'react-select';
import ManagerService from "../../services/ManagerService";
import "./Dashboard.css";
import ReturnButton from "./ReturnButton";

const BaoCaoTinhTrang = ({ setComponentDuocChon }) => {
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [ChiPhi, setCP] = useState(null);
  const [dsTaiXe, setDsTaiXe] = useState([]);
  const [tai_xe_gui, setTxGui] = useState("");
  const [tai_xe_lay, setTxLay] = useState("");
  
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await ManagerService.Lay_DS_Bd_Sc_tram();
        console.log("API Response:", response);

        if (response && Array.isArray(response.data)) {
          setDashboardData(response.data);
        } else {
          setDashboardData([]);
          console.error("Dữ liệu từ API không hợp lệ:", response);
          setErrorMessage("Dữ liệu trả về không đúng định dạng.");
        }
      } catch (error) {
        console.error("Lỗi khi tải dữ liệu:", error);
        setDashboardData([]);
        setErrorMessage("Không thể tải dữ liệu. Vui lòng thử lại sau.");
      } finally {
        setLoading(false);
      }
    };

    const fetchDrivers = async () => {
        try {
            const data = await ManagerService.Lay_DS_Taixe(); 
            if (data && data.data) {
              const options = data.data.map(item => ({
                value: item.username,
                label: `${item.name} - (${item.sdt})`
              }));
              setDsTaiXe(options);
            }
        } catch (error) {
            console.error('Lỗi khi lấy danh sách tài xế:', error);
        }
    };

    fetchDashboardData();
    fetchDrivers();
  }, []);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Đang tải dữ liệu...</p>
      </Container>
    );
  }

  const handleOpenModal = async (record) => {
    setLoading(true);
    try {
      const response = await ManagerService.Lay_CP_Bd_Sc(record.id);
      console.log(response);
      if (response && response.data) {
        setCP(response.data || []);
      } else {
        setCP([]);
      }
    } catch (error) {
      console.error("Lỗi khi tải chi phí:", error);
      setCP([]);
      setErrorMessage("Không thể tải chi phí. Vui lòng thử lại sau.");
    } finally {
      setLoading(false);
    }
    setSelected(record);
    setIsModalOpen(true);
  };  

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelected(null);
  };

  const accept = async (don) => {
    if (!don?.id) {
        alert("Đơn không hợp lệ.");
        return;
    }
    try {
        const response = await ManagerService.Update_Bd_Sc(don.id, "Đang bảo dưỡng - sửa chữa");
        alert(response?.message || "Đã cập nhật đơn Bảo dưỡng - sửa chữa");
        
        // Update the `dashboardData` state so that the change is reflected in the list
        setDashboardData((prevData) =>
          prevData.map((item) =>
            item.id === don.id ? { ...item, trang_thai: "Đang bảo dưỡng - sửa chữa" } : item
          )
        );

        // Also update the `selected` record to reflect the change in modal
        setSelected((prev) => ({ ...prev, trang_thai: "Đang bảo dưỡng - sửa chữa" }));

        handleCloseModal();
    } catch (error) {
        console.error("Lỗi khi cập nhật dữ liệu:", error);
        alert("Không thể cập nhật đơn sửa chữa và bảo dưỡng. " + (error?.message || ""));
    }
  };

  const Cancel = async (don) => {
    if (!don?.id) {
        alert("Đơn không hợp lệ.");
        return;
    }
    try {
        const response = await ManagerService.Update_Bd_Sc(don.id, "Hủy bảo dưỡng - sửa chữa");
        alert(response?.message || "Đã hủy đơn Bảo dưỡng - sửa chữa");
        
        // Update the `dashboardData` state so that the change is reflected in the list
        setDashboardData((prevData) =>
          prevData.map((item) =>
            item.id === don.id ? { ...item, trang_thai: "Hủy bảo dưỡng - sửa chữa" } : item
          )
        );

        // Also update the `selected` record to reflect the change in modal
        setSelected((prev) => ({ ...prev, trang_thai: "Hủy bảo dưỡng - sửa chữa" }));

        handleCloseModal();
    } catch (error) {
        console.error("Lỗi khi cập nhật dữ liệu:", error);
        alert("Không thể cập nhật đơn sửa chữa và bảo dưỡng. " + (error?.message || ""));
    }
  };

  //Lưu lại taixe 
  const Save = async (don) => {
    if (!don?.id) {
      alert("Đơn không hợp lệ.");
      return;
    }
  
    let updateData = {}; 
    updateData.bien_kiem_soat = don.bien_kiem_soat;
  
    // Update tài xế gửi xe (Chỉ gửi nếu có dữ liệu mới)
    if (!don.tai_xe_gui && tai_xe_gui) {
      updateData.tai_xe_gui = tai_xe_gui.value;
    }
    console.log(updateData);

    // Update tài xế lấy xe (Chỉ gửi nếu có dữ liệu mới)
    if (!don.tai_xe_lay && tai_xe_lay) {
        updateData.tai_xe_lay = tai_xe_lay.value;
    }

    // Kiểm tra nếu không có dữ liệu cần cập nhật
    if (Object.keys(updateData).length === 1) { 
      setErrorMessage("Không có thông tin cần cập nhật.");
      return;
    }
  
    try {
      const response = await ManagerService.UpdateTaiXe(don.id, updateData);
      alert(response?.message || "Đã cập nhật thông tin tài xế.");
  
      // Cập nhật lại dữ liệu trong state
      setDashboardData((prevData) =>
        prevData.map((item) =>
          item.id === don.id
            ? { ...item, tai_xe_gui: tai_xe_gui.label, tai_xe_lay: tai_xe_lay.label }
            : item
        )
      );
      
      
      
  
      // Cập nhật trong modal nếu đang mở
      setSelected((prev) => ({
        ...prev,
        tai_xe_gui: tai_xe_gui.label,
        tai_xe_lay: tai_xe_lay.label
      }));
      
  
      handleCloseModal();
    } catch (error) {
      console.error("Lỗi khi cập nhật tài xế:", error);
      alert("Không thể cập nhật tài xế. " + (error?.message || ""));
    }
  };
  

  return (
    <Container fluid className="mt-4 BaoCaoTinhTrangComponent">
      <ReturnButton setComponentDuocChon={setComponentDuocChon} />

      <h2>Danh sách chuyến xe đi Bảo dưỡng - Sửa chữa</h2>

      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

      {Array.isArray(dashboardData) && dashboardData.length > 0 ? (
        <Row xs={1} sm={2} md={3} lg={3} xl={3} className="g-4">
          {dashboardData.map((chuyen) => (
            <Col key={chuyen.id}>
              <Card>
                <Card.Body style={{ textAlign: "center" }}>
                  <Card.Title className="text-center fw-bold">
                    Mã Chuyến: {chuyen.id}
                  </Card.Title>
                  <Card.Text>Biển kiểm soát: {chuyen.bien_kiem_soat || "N/A"}</Card.Text>
                  <Card.Text>
                    Ngày sửa chữa:{" "}
                    {chuyen.ngay_sua_chua
                      ? new Date(chuyen.ngay_sua_chua).toLocaleDateString()
                      : "N/A"}
                  </Card.Text>
                  <Card.Text>Loại: {chuyen.loai || "N/A"}</Card.Text>
                  <Card.Text>Trạm: {chuyen.ten_tram || "N/A"}</Card.Text>
                  <Card.Text>Loại xe: {chuyen.loai_xe || "N/A"}</Card.Text>
                  <Card.Text>Trạng thái: {chuyen.trang_thai || "N/A"}</Card.Text>

                  <div className="d-flex gap-2 justify-content-between mt-3">
                    <Button variant="primary" onClick={() => handleOpenModal(chuyen)}>
                      Chi tiết
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <p className="text-center mt-4">Không có dữ liệu để hiển thị.</p>
    )}

      {/* Detail Modal */}
      <Modal show={isModalOpen} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Đơn bảo dưỡng - sửa chữa</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
            {selected && (
            <Row className="g-3">
                <Col xs={6}>
                <p><strong>Mã đơn:</strong> {selected.id}</p>
                </Col>
                <Col xs={6}>
                <p><strong>Biển kiểm soát:</strong> {selected.bien_kiem_soat || "N/A"}</p>
                </Col>
                
                <Col xs={6}>
                <p><strong>Ngày sửa chữa:</strong> {selected.ngay_sua_chua ? new Date(selected.ngay_sua_chua).toLocaleDateString() : "N/A"}</p>
                </Col>
                <Col xs={6}>
                <p><strong>Trạm:</strong> {selected.ten_tram || "N/A"}</p>
                </Col>

                <Col xs={6}>
                <p><strong>Loại:</strong> {selected.loai || "N/A"}</p>
                </Col>
                <Col xs={6}>
                <p><strong>Trạng thái:</strong> {selected.trang_thai || "N/A"}</p>
                </Col>

                {/* Chọn tài xế nếu thiếu */}
                <Col xs={6}>
                  <p><strong>Tài xế gửi xe:</strong></p>
                  {selected.tai_xe_gui ? (
                    <p>{selected.tai_xe_gui}</p>
                  ) : dsTaiXe.length > 0 ? (
                    <Select
                      placeholder="Chọn tài xế gửi"
                      options={dsTaiXe}
                      showSearch
                      optionFilterProp="label"
                      style={{ width: 200 }}
                      value={tai_xe_gui}
                      onChange={(value) => setTxGui(value)} 
                      getOptionLabel={(option) => option.label} 
                    />
                  ) : (
                    <p>Loading...</p>
                  )}
                </Col>
                <Col xs={6}>
                  <p><strong>Tài xế lấy xe:</strong></p>
                  {selected.tai_xe_lay ? (
                    <p>{selected.tai_xe_lay}</p>
                  ) : dsTaiXe.length > 0 ? (
                    <>
                      {console.log("Options:", dsTaiXe)}
                      <Select
                        placeholder="Chọn tài xế lấy"
                        options={dsTaiXe}
                        showSearch
                        optionFilterProp="label"
                        style={{ width: 200 }}
                        value={tai_xe_lay}
                        onChange={(value) => setTxLay(value)} 
                        getOptionLabel={(option) => option.label} 
                      />
                    </>
                  ) : (
                    <p>Loading...</p>
                  )}
                </Col>

                <Col xs={12}>
                <p><strong>Ghi chú:</strong> {selected.ghi_chu || "Không có ghi chú"}</p>
                </Col>
                <Col xs={12}>
                <p><strong>Giá:</strong> {selected.gia ? `${selected.gia} VNĐ` : "N/A"}</p>
                </Col>

                <Col xs={12}>
                <p><strong>Chi phí phụ:</strong></p>
                {ChiPhi && ChiPhi.length > 0 ? (
                    <ul>
                    {ChiPhi.map((cp, index) => (
                        <li key={index}>
                        {cp.name}: {cp.gia ? `${cp.gia} VNĐ` : "N/A"}
                        </li>
                    ))}
                    </ul>
                ) : (
                    <p>Không có dữ liệu chi phí phụ.</p>
                )}
                </Col>

                <Col xs={12}>
                <p><strong>Tổng chi phí:</strong> {selected.tong_cp ? `${selected.tong_cp} VNĐ` : "N/A"}</p>
                </Col>
            </Row>
            )}
        </Modal.Body>

        <Modal.Footer>
          <Row className="w-100">
            {/* "Chấp nhận" & "Lưu" in the same line */}
            <Col xs={12} className="d-flex gap-2 justify-content-between">
              {selected?.trang_thai === "Đã báo giá" && (
                <Button variant="success" onClick={() => accept(selected)}>
                  Chấp nhận
                </Button>
              )}
              {(!selected?.tai_xe_gui || !selected?.tai_xe_lay) && (
                <Button variant="primary" onClick={() => Save(selected)}>
                  Lưu
                </Button>
              )}
            </Col>

            {/* "Hủy đơn" & "Đóng" in the same line */}
            <Col xs={12} className="d-flex gap-2 justify-content-between mt-2">
              <Button variant="danger" onClick={() => Cancel(selected)}>
                Hủy đơn
              </Button>
              <Button variant="secondary" onClick={handleCloseModal}>
                Đóng
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default BaoCaoTinhTrang;
